<div fxLayout="column" fxLayoutAlign="center center" [ngStyle]="{'max-height.px': innerHeight}"fxLayoutGap="50px">


  <div fxLayout="column" fxLayoutAlign="center center" class="full-w titac borderxs" ngClass.xs="noborderxs">

    <mat-icon class="whited-ico ">access_alarm</mat-icon>

    <div class=" whited-ico fontxlarge boldest"> Tic TAc !</div>

  </div>


  <div fxLayout="column" fxLayoutAlign="center center" class="layout-padd " fxLayoutGap="50px">

    <mat-dialog-title fxLayoutAlign="center center" class="boldest fontmedium">
      {{"cancel_order_di.continueOrder" | translate}}</mat-dialog-title>

    <div fxLayout="row" class="layout-padd boldest fontlarge" fxLayoutAlign="center center"
      [innerHtml]="'cancel_order_di.cancelOrder2' | translate:{'timeSec': timeSec}"></div>


    <!-- button -->

    <div class="layout-padd positionBottomtouchcancel full-w" fxLayoutGap="10px" fxflex>
      <button mat-stroked-button class="warn-ico rounded-button" fxFlex (click)="remove_order()">
        <span class="mat-title">{{ "button.no"|translate}}</span>
      </button>

      <button cdkFocusInitial mat-stroked-button class="great2 rounded-button" fxFlex angulartics2On="click"
        (click)="closeDial()">

        <span class="mat-title">{{"button.yes"|translate}}</span>
      </button>



    </div>


  </div>
</div>